
export enum QualificationType{
    knowledge = 0,
    competency = 1,
    combined = 2
}